import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TransactionDocumentSourceProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `TransactionDocumentSetup/GetDocumentSource/${props.documentId}/${props.type}/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `TransactionDocumentSetup/UploadDocumentSource/`, method: 'POST', payload: props.data, multipart: true, secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `TransactionDocumentSetup/DeleteDocumentSource/${props.id}`, payload: props, method: 'POST', secure: true });
    }, [execute]);

    const value = { selectRecord, newRecord, deleteRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionDocumentSourceStore = () => React.useContext(Context);
